import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {TeammateModel} from '../../../../../../libs/shared/core/src/models/api/teammateModel';
import {TeammateAvatar} from '../../../../../../libs/shared/ui/src/components/avatar/teammateAvatar';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useCompactP2Context} from '../../compactP2Context';

/*
 * Props.
 */

export interface CellAuthorWrapperProps {
  author: TeammateModel;
  isSelected?: boolean;
  isCompact?: boolean;
}

/*
 * Style.
 */

const StyledAuthorDiv = styled.div<{$isCompact: boolean}>`
  ${(p) => !p.$isCompact && `grid-area: bottom-left;`}
`;

const StyledContentDiv = styled.div<{$isCompact: boolean}>`
  ${(p) => !p.$isCompact && `grid-area: bottom-line;`}
  display: flex;
  min-width: 0;
`;

/*
 * Component.
 */

export const CellAuthorWrapper: FC<PropsWithChildren<CellAuthorWrapperProps>> = (props) => {
  const {isCompact: isGloballyCompact} = useCompactP2Context();
  // Passed down props have higher priority than the global value.
  const computedIsCompact = props.isCompact === undefined ? isGloballyCompact : props.isCompact;
  return (
    <>
      <StyledAuthorDiv $isCompact={computedIsCompact}>
        <TeammateAvatar size={VisualSizesEnum.SMALL} teammate={props.author} isSelected={props.isSelected} />
      </StyledAuthorDiv>
      <StyledContentDiv $isCompact={computedIsCompact}>{props.children}</StyledContentDiv>
    </>
  );
};
